// extracted by mini-css-extract-plugin
export default {"button":"Button_button__DwPJl","disabled":"Button_disabled__7oiHR"};